import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';

const getUrl = ({ host, projectId }: { host: string; projectId: string }) => {
  return `${host}/projects/${projectId}`;
};

export const DeleteProject = async ({ host, token, projectId }: { host: string; token: string; projectId: string }): Promise<void> => {
  try {
    const url = getUrl({ host, projectId });

    const options: AxiosRequestConfig = {
      url,
      method: 'DELETE',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
    };

    (await axios(options)) as AxiosResponse<void>;
  } catch (error) {
    throw getErrorFormat(error);
  }
};
